import clsx from "clsx";

interface IconProps {
	className?: string
	theme?: 'light' | 'dark'
}

export const WhatsappIcon: React.FC<IconProps> = ({ className, theme= 'dark' }) => {
	return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 12 12"
      className={clsx(className, 'w-[1.2rem] h-[1.2rem]')}
    >
      <path
        fill={theme === 'light' ? '#FF77A8' : '#131313'}
        d="M10.207 1.748A5.888 5.888 0 006.002.003C2.727.003.057 2.672.054 5.948c0 1.049.275 2.07.793 2.973l-.84 3.082 3.152-.826a5.925 5.925 0 002.843.723h.003c3.276 0 5.944-2.668 5.947-5.947a5.925 5.925 0 00-.453-2.277 5.925 5.925 0 00-1.292-1.928zm-4.205 9.146a4.95 4.95 0 01-2.517-.69l-.18-.108-1.87.49.499-1.824-.117-.188a4.92 4.92 0 01-.755-2.63 4.948 4.948 0 014.943-4.937A4.92 4.92 0 019.5 2.455a4.92 4.92 0 011.446 3.495 4.951 4.951 0 01-4.944 4.944zm2.711-3.7a25.682 25.682 0 00-1.015-.485c-.136-.049-.236-.074-.333.074a8.87 8.87 0 01-.47.582c-.086.1-.175.11-.323.037-.148-.075-.627-.231-1.194-.739a4.534 4.534 0 01-.827-1.029c-.086-.148-.009-.228.066-.302.065-.066.147-.174.222-.26.075-.085.1-.148.148-.247.049-.1.026-.186-.011-.26-.038-.074-.334-.807-.46-1.103-.12-.291-.241-.251-.333-.255-.085-.005-.185-.005-.285-.005a.547.547 0 00-.397.185c-.136.149-.518.508-.518 1.24 0 .734.533 1.438.608 1.538.073.1 1.045 1.599 2.537 2.244.352.153.63.244.847.313.356.114.678.097.934.06.285-.043.878-.36 1.004-.707.123-.348.123-.645.085-.707-.037-.064-.136-.1-.285-.175z"
      ></path>
    </svg>
  );
}